import type { ProductCard } from '@repo/supergraph/roundup/base/types';
import type { Graph, ItemList, WithContext } from 'schema-dts';
import { LinkedDataJson } from '..';
import { getProductListSchema } from './schema';

export type ProductListDataProps = WithContext<ItemList> | Graph;

export const ProductListData = ({
  offers,
  title,
  id,
  url,
}: {
  offers: ProductCard[];
  title: string;
  id: string;
  url: string;
}) => {
  return <LinkedDataJson<ItemList> id={id} schema={getProductListSchema({ offers, title, url })} />;
};
